import { render, staticRenderFns } from "./GestionInfoHidrocarburos.vue?vue&type=template&id=a6b34f7e"
import script from "./GestionInfoHidrocarburos.vue?vue&type=script&lang=js"
export * from "./GestionInfoHidrocarburos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports